/* eslint-disable import/prefer-default-export */
import { defineStore } from 'pinia';

import { FormValues as InviteFormValues } from '@/components/pages/Doctors/Patients/Container.vue';
import { FormValues } from '@/components/pages/Doctors/SignUp/Container.vue';
import { Doctor } from '@/types/doctor';
import { apiGet, apiPost } from '@/utils/api';

export const useCurrentDoctorStore = defineStore('currentUserDoctor', {
  state: () => ({
    user: null as Doctor | null,
  }),
  actions: {
    // ログイン状態を確認する
    async isLoggedIn() {
      const { data } = await apiGet<Doctor>('/api/doctor/me');

      if (data) {
        this.user = data;
      }

      return !!data;
    },
    // 仮登録する
    async temporaryRegistration(email: string) {
      return await apiGet('/sanctum/csrf-cookie').then(
        async () => await apiPost('/api/doctor/registration', { email })
      );
    },
    // メール認証のトークンをチェックする
    async registrationVerify(token: string) {
      return await apiPost('/api/doctor/registration/verify', { token });
    },
    // 患者を仮登録する
    async invitePatient(formValues: InviteFormValues) {
      return await apiPost('/api/doctor/invitation', formValues);
    },
    //  ログインをする
    async login(email: string, password: string) {
      return await apiGet('/sanctum/csrf-cookie').then(async () => {
        const params = { email, password };
        const res = await apiPost<Doctor>('/api/doctor/login', params);

        if (res.success) {
          this.user = res.data;
        }

        return res;
      });
    },
    //  会員登録をする
    async register(formValues: FormValues, registration_token: string) {
      return await apiGet('/sanctum/csrf-cookie').then(async () => {
        const res = await apiPost<Doctor>('/api/doctor/me', {
          ...formValues,
          registration_token,
        });

        return res;
      });
    },
    // パスワード再設定メール送信
    async sendPasswordResetLink(email: string) {
      const params = { email };
      return await apiPost('/api/doctor/password/reset-request', params);
    },
    // パスワード再設定
    async resetPassword(
      userId: number,
      token: string,
      password: string,
      password_confirmation: string
    ) {
      const params = {
        id: userId,
        token,
        password,
        password_confirmation,
      };

      return await apiPost('/api/doctor/password/reset', params);
    },
    // ログアウト
    async logout() {
      const res = await apiPost('/api/doctor/logout');
      if (res.success) {
        this.user = null;
      }

      return res;
    },
    // メールアドレス認証
    async verifyEmail(userId: number, hash: string) {
      return await apiGet(`/api/doctor/email/verify/${String(userId)}/${hash}`);
    },
  },
});
